
import Divisor from './Divisor';
import TituloNegrito from './TituloNegrito';

import Image from 'react-bootstrap/Image';

import header from '../images/rpc-header.png'

import constantes from '../helpers/constanteHelper';
import { retornarTexto } from '../helpers/textoHelper'

function DetalhesCertificacaoRedutor({ resolucaoMobile, idioma }) {
    return (
        <>
            <Divisor />
            <TituloNegrito texto={retornarTexto(idioma, 'redutor')} />
            <Image style={{ height: '400px', objectFit: 'contain', padding: '20px' }} src={header} alt='logo' fluid />
            <span className='mt-4 mb-5' style={{ width: resolucaoMobile ? '90vw' : '70vw', color: constantes.CORES.BRANCO_PADRAO, fontSize: resolucaoMobile ? '16px' : '20px', textAlign: resolucaoMobile ? 'justify' : 'center', whiteSpace: 'pre-line' }}>
            {retornarTexto(idioma, 'descricaoCertificacaoRedutorParte1')}<br /><br />
            {retornarTexto(idioma, 'descricaoCertificacaoRedutorParte2')}
            </span>
        </>
    );
}
export default DetalhesCertificacaoRedutor;
